import { render, staticRenderFns } from "./DecorationGallery.vue?vue&type=template&id=3ee11b24&scoped=true"
import script from "./DecorationGallery.vue?vue&type=script&lang=js"
export * from "./DecorationGallery.vue?vue&type=script&lang=js"
import style0 from "./DecorationGallery.vue?vue&type=style&index=0&id=3ee11b24&prod&scoped=true&lang=css"
import style1 from "./DecorationGallery.vue?vue&type=style&index=1&id=3ee11b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee11b24",
  null
  
)

export default component.exports